import {get, every, flow, isFinite} from 'lodash/fp'
import React, {Component} from 'react'

import {replaceAt} from '../../utils'
import Input from '../Input'

import './styles.css'

const floatRegex = new RegExp(/^\d*\.?\d*$/)
class InputAnswers extends Component {
  createOnChange = (answer, idx) => value => {
    const {answer, onChange} = this.props
    if (floatRegex.test(value)) {
      onChange(replaceAt(answer, idx, value))
    }
  }

  render() {
    const {question, answer} = this.props
    const {answers} = question
    const isValid = every(flow(parseFloat, isFinite))(answer)
    return (
      <div className="input-answers">
        {answers.map((ans, idx) => (
          <div className="input-answer" key={ans.value}>
            <Input
              className="input-answer-num"
              value={get(idx, answer)}
              onChange={this.createOnChange(ans, idx)}
            />
            <div className="input-answer-text">
              <div className="input-answer-value">
                {ans.value}
              </div>
              <div className="input-answer-tagline">
                {ans.meta}
              </div>
            </div>
          </div>
        ))}
        {answers.length > 1 && !isValid && <div className="input-warning">Please fill out all entries to continue.</div>}
      </div>
    )
  }
}

export default InputAnswers



// WEBPACK FOOTER //
// ./src/components/Question/InputAnswers.js